var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"storefront",attrs:{"fluid":_vm.isMobile}},[(_vm.showCurrentShop)?_c('orderModal',{attrs:{"shop":_vm.currentShop}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }